import classNames from 'classnames';
import type { JSX } from 'react';
import { DiNavDropdown } from '../../DiNav/DiNavDropdown/DiNavDropdown';
import HeaderNavDropdownItem from '../HeaderNavDropdownItem/HeaderNavDropdownItem';
import HeaderNavItem from '../HeaderNavItem/HeaderNavItem';
import type { HeaderNavDropdownProps } from './HeaderNavDropdown.types';

// Header height 64px => Trigger height 38px => 64 - 38 = 26px / 2 = 13px
// To align the dropdown with the bottom of the header
const DROPDOWN_OFFSET_OPTIONS = { offset: { mainAxis: 13 } };

/**
 * A `HeaderNavDropdown` is a dropdown component for the `HeaderNav`
 *
 * @example
 *
 * ```tsx
 * <HeaderNavDropdown label="label" currentIndex={0} />
 * ```
 */
export function HeaderNavDropdown({
  currentIndex = -1,
  options = DROPDOWN_OFFSET_OPTIONS,
  ...props
}: HeaderNavDropdownProps): JSX.Element {
  return (
    <DiNavDropdown
      dropdownMenuClassName={classNames([
        'bg-dt-surface-profile-card-profile-card rounded-dt-radius-large',
        'py-dt-spacing-100 shadow-card w-max outline-none',
      ])}
      trigger={<HeaderNavItem label="" font="hind" />}
      dropdownMenuItem={<HeaderNavDropdownItem label="" />}
      currentIndex={currentIndex}
      options={options}
      {...props}
    />
  );
}
